// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
/* eslint-disable @typescript-eslint/no-explicit-any */

import { createAxios } from 'ts/createAxios';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';
import {
  TenantLoginHistory,
  LoginHistoryGetParams,
  OverallLoginHistory,
} from 'util/Types';

export const getTenantLoginHistories = async (p: {
  params: LoginHistoryGetParams;
  successCallback?: (data: TenantLoginHistory[]) => void;
  failedCallback?: (error: any) => void;
}) => {
  const { params, successCallback, failedCallback } = p;

  try {
    const { data } = await createAxios().post<TenantLoginHistory[]>(
      API_ENDPOINTS.TENANT_LOGIN_HISTORIES_TOTAL,
      params
    );

    successCallback?.(data);
  } catch (error) {
    handleError(error);
    failedCallback?.(error);
  }
};

export const getOverallLoginHistories = async (p: {
  params: LoginHistoryGetParams;
  successCallback?: (data: OverallLoginHistory[]) => void;
  failedCallback?: (error: any) => void;
}) => {
  const { params, successCallback, failedCallback } = p;

  try {
    const { data } = await createAxios().post<OverallLoginHistory[]>(
      API_ENDPOINTS.LOGIN_HISTORIES_TOTAL,
      params
    );

    successCallback?.(data);
  } catch (error) {
    handleError(error);
    failedCallback?.(error);
  }
};
